/* tough-cookie/lib/permuteDomain */ function _(require, module, exports) {
    var pubsuffix = require(356) /* ./pubsuffix */;
    // Gives the permutation of all possible domainMatch()es of a given domain. The
    // array is in shortest-to-longest order.  Handy for indexing.
    function permuteDomain(domain) {
        var pubSuf = pubsuffix.getPublicSuffix(domain);
        if (!pubSuf) {
            return null;
        }
        if (pubSuf == domain) {
            return [domain];
        }
        var prefix = domain.slice(0, -(pubSuf.length + 1)); // ".example.com"
        var parts = prefix.split('.').reverse();
        var cur = pubSuf;
        var permutations = [cur];
        while (parts.length) {
            cur = parts.shift() + '.' + cur;
            permutations.push(cur);
        }
        return permutations;
    }
    exports.permuteDomain = permuteDomain;
}
